import React from "react";

import ConditionAmount from "./ConditionAmount";

const ConditionJudgementAmount = (props) => {
  return <ConditionAmount {...props} label="Judgement Amount:" />;
};

export default ConditionJudgementAmount;
